import React, { Fragment } from 'react';
import { FileTextIcon } from 'lucide-react';
import { motion } from 'framer-motion';
export function ModulesSection() {
  const modules = [{
    number: 1,
    pages: 14,
    title: 'La Regla Madre de la Pérdida de Grasa',
    description: <Fragment data-id="element-214">
          Vas a entender cómo funciona realmente la pérdida de grasa y por qué
          el <strong data-id="element-215">déficit calórico es la base de todo.</strong>
        </Fragment>
  }, {
    number: 2,
    pages: 19,
    title: 'Tus Calorías Exactas para Bajar Grasa',
    description: <Fragment data-id="element-216">
          Vas a aprender a calcular cuántas calorías necesitás comer para{' '}
          <strong data-id="element-217">empezar a bajar grasa de forma inteligente.</strong>
        </Fragment>
  }, {
    number: 3,
    pages: 19,
    title: 'Cómo Comer para Bajar Sin Cagarte de Hambre',
    description: <Fragment data-id="element-218">
          Vas a descubrir cómo organizar tus comidas para tener{' '}
          <strong data-id="element-219">saciedad, energía y control</strong> sin vivir con hambre.
        </Fragment>
  }, {
    number: 4,
    pages: 19,
    title: 'Alimentos que Adelgazan y Etiquetas que Engañan',
    description: <Fragment data-id="element-220">
          Vas a conocer qué alimentos te ayudan a bajar grasa y cuáles pueden{' '}
          <strong data-id="element-221">hacerte pasar de calorías sin darte cuenta.</strong>
        </Fragment>
  }, {
    number: 5,
    pages: 19,
    title: 'Control Sin Obsesión: Cómo Medir Tu Progreso Real',
    description: <Fragment data-id="element-222">
          Vas a aprender a medir tu progreso usando peso, cintura, fotos, ropa,
          hábitos y rendimiento <strong data-id="element-223">sin obsesionarte.</strong>
        </Fragment>
  }, {
    number: 6,
    pages: 15,
    title: 'Entrená Fuerza y Quedá Firme, No Flácido',
    description: <Fragment data-id="element-224">
          Vas a entender cómo entrenar para{' '}
          <strong data-id="element-225">mantener músculo, verte más firme</strong> y evitar quedar
          "flaco y blando".
        </Fragment>
  }, {
    number: 7,
    pages: 28,
    title: 'Cardio y Pasos que Sí Queman Grasa',
    description: <Fragment data-id="element-226">
          Vas a saber cómo usar los pasos, el cardio y el movimiento diario para{' '}
          <strong data-id="element-227">aumentar tu gasto sin destruirte.</strong>
        </Fragment>
  }, {
    number: 8,
    pages: 47,
    title: 'Tu Plan de Definición en 12 Semanas',
    description: <Fragment data-id="element-228">
          Vas a tener una estructura clara para aplicar todo el sistema durante
          90 días, con <strong data-id="element-229">fases progresivas y ajustes.</strong>
        </Fragment>
  }];
  return <section className="py-14 md:py-20 bg-zinc-900 pt-[20px] pb-[20px] mt-[-1px] mb-[-1px]" data-id="element-230">
      <div className="container mx-auto px-5 sm:px-6 md:px-8" data-id="element-231">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="max-w-6xl mx-auto" data-id="element-232">
          <h2 className="text-4xl md:text-6xl lg:text-7xl font-display text-white md:mb-24 text-center uppercase tracking-tight leading-[0.95] mt-[15px] mb-[15px]" data-id="element-233">
            Dentro de Plan Anti Panza vas a encontrar{' '}
            <span className="text-orange-500 pt-[0px] pb-[0px]" data-id="element-234">
              8 módulos paso a paso
            </span>
          </h2>

          <div className="grid md:grid-cols-2 gap-6 md:gap-8" data-id="element-235">
            {modules.map((module, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.4,
            delay: 0.05 * index
          }} className="bg-black border border-zinc-800 rounded-2xl p-8 hover:border-orange-500/50 transition-colors group pt-[32px] pb-[32px] mt-[-5px] mb-[-5px]" data-id="element-236">
                <div data-id="element-237">
                  <div className="mt-[-27px] mb-[-27px]" data-id="element-238">
                    <div className="flex flex-wrap items-center gap-3 mb-2" data-id="element-239">
                      <span className="inline-block text-xs md:text-sm font-bold text-orange-500 uppercase tracking-[0.2em]" data-id="element-240">
                        Módulo {module.number}
                      </span>
                      <span className="inline-flex items-center gap-1.5 bg-zinc-800 border border-zinc-700 text-zinc-300 px-2.5 py-1 rounded-full text-[10px] md:text-xs font-bold uppercase tracking-wider" data-id="element-241">
                        <FileTextIcon className="w-3.5 h-3.5 text-orange-500" data-id="element-242" />
                        {module.pages} Páginas
                      </span>
                    </div>
                    <h3 className="text-2xl font-display text-white uppercase leading-tight tracking-wide" data-id="element-243">
                      {module.title}
                    </h3>
                  </div>
                </div>
              </motion.div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}